module.exports = __webpack_public_path__ + "static/media/GreenV.b7707c14.png";